import React from 'react';

import styles from './widgets.module.css';
import LoglyticsList from '../../loglytics/loglytics_list.component';

// below 8 columns the full row (device count, file:line, os/app versions) doesn't fit
const LoglyticsWidget = ({ span }: { span: number }) => (
  <div>
    <div className={styles.chartTitle}> Loglytics</div>
    <div className={styles.loglyticsBody}>
      <LoglyticsList compact={span < 8} />
    </div>
  </div>
);

export default LoglyticsWidget;
